export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/leonard-cotte-3838771f63b88d78ca687e8883b48dc9.jpg";